export default __webpack_public_path__ + "static/media/pdf-placeholder.8b801131.jpg";